module.exports = __webpack_public_path__ + "static/media/ash.60b95b5d.svg";